import { Icon } from '@zenchef/ds-react'

const ZenchefLogo = () => {
  return <Icon name='zenchef' fontSize='20px' />
}

export default ZenchefLogo
